function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M843.82 189.01c21.47-9.04 46.16-5.69 64.46 8.73a64.008 64.008 0 0 1 23.52 60.64l-96.77 586.97c-9.38 56.62-71.51 89.09-123.43 60.88-43.44-23.59-107.95-59.95-165.97-97.87-29.01-18.99-117.89-79.79-106.97-123.05 9.39-36.99 158.72-176 244.05-258.65 33.5-32.47 18.22-51.2-21.34-21.33C563.15 479.48 405.46 592.25 353.32 624c-45.99 27.99-69.97 32.77-98.64 27.99-52.31-8.7-100.82-22.19-140.42-38.61-53.5-22.19-50.9-95.74-.04-117.16z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgTelegram;